import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("app", ["serviceFormTabIndexes"]),
  },
  methods: {
    getTabIndex(key) {
      const index = (this.serviceFormTabIndexes || [])
        .filter((i) => i.enabled)
        .findIndex((i) => i.key === key);
      if (index >= 0) {
        return String(index + 1);
      }
      return "-1";
    },
  },
};
